import { authClient, API } from "../../utils/index";

export const getEscapeRooms = () => {
	return authClient().get(`${API}/escape-room`);
};

export const getEscapeRoomById = (id) => {
	return authClient().get(`${API}/escape-room/${id}`);
};

export const postEscapeRoom = (data) => {
	return authClient().post(`${API}/escape-room`, data);
};

export const updateEscapeRoom = (id, data) => {
	return authClient().put(`${API}/escape-room/${id}`, data);
};

export const deleteEscapeRoom = (id) => {
	return authClient().delete(`${API}/escape-room/${id}`);
};
